var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentPushToCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.22,19.44,30,8.22a2.08,2.08,0,0,0-1.73-2.39h0L4.54,2A2.08,2.08,0,0,0,2.15,3.76L1,10.45l.33,8.92Z",
    fill: "#1785c1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.24,5.83,21.51,4.75C17,11.67,9.68,16.46,4.08,19.38l24.14.06L30,8.22a2.08,2.08,0,0,0-1.73-2.39Z",
    fill: "#0077ba"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.13,10h24a2.1,2.1,0,0,1,2.09,2.09V25.7a2.09,2.09,0,0,1-2.09,2.08h-24A2.08,2.08,0,0,1,0,25.7V12.13A2.09,2.09,0,0,1,2.13,10Z",
    fill: "#4ca0cf"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.65,
    y: 12.65,
    width: 5.22,
    height: 4.17,
    fill: "#fdb62f"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.65,
    y: 14.22,
    width: 1.57,
    height: 1.04,
    fill: "#fd7b2f"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.3,
    y: 14.22,
    width: 1.57,
    height: 1.04,
    fill: "#fd7b2f"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.13,
    y: 20.48,
    width: 3.13,
    height: 1.04,
    fill: "#b2d6ea"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.34,
    y: 20.48,
    width: 3.13,
    height: 1.04,
    fill: "#b2d6ea"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.56,
    y: 20.48,
    width: 3.13,
    height: 1.04,
    fill: "#b2d6ea"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3,
    y: 20.48,
    width: 7.34,
    height: 4.24,
    fill: "#fdb62f"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2.13,
    y: 23.61,
    width: 13.57,
    height: 1.04,
    fill: "#b2d6ea"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3,
    y: 12.65,
    width: 1.04,
    height: 2.09,
    fill: "#b2d6ea"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 20.39,
    y: 12.65,
    width: 1.04,
    height: 2.09,
    fill: "#b2d6ea"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 22.48,
    y: 12.65,
    width: 1.04,
    height: 2.09,
    fill: "#b2d6ea"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 24.56,
    y: 12.65,
    width: 1.04,
    height: 2.09,
    fill: "#b2d6ea"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentPushToCard);
export default __webpack_public_path__ + "static/media/payment-push-to-card.4fff9b9a2d65bd1ded19e11f855b1dd3.svg";
export { ForwardRef as ReactComponent };